// extracted by mini-css-extract-plugin
var _1 = "BeastPart__img--xD5Sd";
export { _1 as "img" }
